// What the About you page and the chat tell each other, as window events
// (the app's way, like 'refresh-profile'): a fact changed somewhere, so every
// screen showing it reads it again; and "open the setup in the chat".

/** Said when a fact changes; `from` names who changed it ('setup', 'about-you'). */
export const FACTS_CHANGED = 'about-you-changed';
export const factsChanged = (from) => {
  try { window.dispatchEvent(new CustomEvent(FACTS_CHANGED, { detail: { from } })); } catch { /* no window */ }
};

/** Asks the chat to open the setup (the About you page's "Continue in chat"). */
export const OPEN_SETUP = 'open-setup';
export const openSetup = () => {
  try { window.dispatchEvent(new CustomEvent(OPEN_SETUP)); } catch { /* no window */ }
};

/** Asks the shell to bring the chat into view where a page covers it. */
export const SHOW_CHAT = 'show-chat';
export const showChat = () => {
  try { window.dispatchEvent(new CustomEvent(SHOW_CHAT)); } catch { /* no window */ }
};
